__turbopack_context__.v({
  "hasReacted": "_4O-l-G_hasReacted",
  "reactionBadge": "_4O-l-G_reactionBadge",
});
